class ProductAddons extends HTMLElement {
  constructor() {
    super();
    this.productForm = document.querySelector(".main-product__form");
    this.cartDrawer = document.querySelector("cart-drawer");
    this.variantSelector = document.querySelector(
      'select[name="id"], input[name="id"]',
    );
    window.submissionId = this.generateUUID();
    this.isFormSubmitting = false;
  }

  connectedCallback() {
    if (this.variantSelector) {
      this.variantSelector.addEventListener(
        "change",
        this.handleVariantChange.bind(this),
      );
    }

    if (this.productForm) {
      this.productForm.addEventListener(
        "submit",
        this.handleFormSubmit.bind(this),
      );
    }
  }

  disconnectedCallback() {
    if (this.variantSelector) {
      this.variantSelector.removeEventListener(
        "change",
        this.handleVariantChange.bind(this),
      );
    }

    if (this.productForm) {
      this.productForm.removeEventListener(
        "submit",
        this.handleFormSubmit.bind(this),
      );
    }
  }

  generateUUID() {
    // Older iOS (<15.4) / Android WebViews lack crypto.randomUUID. Without a
    // fallback this throws, window.submissionId stays undefined, and the book
    // ships with no _main_id while the giftbox gets _addon_id="" (stripped by
    // sanitizeFormData), producing a "missing _addon_id" decline.
    const newUUID =
      typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
        ? crypto.randomUUID()
        : this.uuidv4Fallback();
    this.submissionId = newUUID;
    return newUUID;
  }

  uuidv4Fallback() {
    const bytes = new Uint8Array(16);
    if (
      typeof crypto !== "undefined" &&
      typeof crypto.getRandomValues === "function"
    ) {
      crypto.getRandomValues(bytes);
    } else {
      for (let i = 0; i < 16; i += 1) bytes[i] = Math.floor(Math.random() * 256);
    }
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0"));
    return (
      hex.slice(0, 4).join("") +
      "-" +
      hex.slice(4, 6).join("") +
      "-" +
      hex.slice(6, 8).join("") +
      "-" +
      hex.slice(8, 10).join("") +
      "-" +
      hex.slice(10, 16).join("")
    );
  }

  async handleVariantChange() {
    const variantId = this.variantSelector.value;
    const sectionId = this.dataset.sectionId;

    try {
      const response = await fetch(
        `${window.location.pathname}?section_id=${sectionId}&variant=${variantId}`,
      );

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // Find the new addons container
      const newAddonsContainer = doc.querySelector("[data-addon-container]");

      if (newAddonsContainer) {
        // Replace the current addons
        const currentAddonsContainer = this.querySelector(
          "[data-addon-container]",
        );
        if (currentAddonsContainer) {
          currentAddonsContainer.innerHTML = newAddonsContainer.innerHTML;
        }
      }

      // Update the variant ID
      this.dataset.variantId = variantId;
    } catch (error) {
      console.error("Error updating addons:", error);
    }
  }

  async handleFormSubmit(event) {
    if (this.isFormSubmitting) return; // Prevent multiple submissions
    this.isFormSubmitting = true;

    event.preventDefault();

    window.submissionId = this.generateUUID();
    this.productForm.dispatchEvent(new Event("submit", { bubbles: true }));

    setTimeout(() => {
      this.isFormSubmitting = false;
    }, 1000);
  }
}

customElements.define("product-addons", ProductAddons);
